import { CampaignBean, CampaignControllerApi, ItemResponseCampaignBeanObject, ListResponseCampaignBean } from 'src/api/api'
import { BaseApi, configuration } from '../../../api/BaseApi'

class CampaignApi extends BaseApi {
    api: CampaignControllerApi

    constructor() {
        super()
        this.api = new CampaignControllerApi(configuration, configuration.basePath, this.fetch)
    }

    list(size: number = 20, page: number = 1, sort, search, advertiser, status): Promise<ListResponseCampaignBean> {
        return this.call(() => this.api.campaignList(search, advertiser, status, { query: { size, page, sort } }))
    }

    all(): Promise<ListResponseCampaignBean> {
        return this.call(() => this.api.campaignList())
    }

    create(campaign: CampaignBean): Promise<ItemResponseCampaignBeanObject> {
        return this.call(() => this.api.createCampaign(campaign))
    }

    edit(id: any, bean: CampaignBean): Promise<ItemResponseCampaignBeanObject> {
        return this.call(() => this.api.editCampaign(bean, id))
    }

    view(id: any): Promise<ItemResponseCampaignBeanObject> {
        return this.call(() => this.api.campaign(id))
    }

    delete(id: number): Promise<void> {
        return this.call(() => this.api.deleteCampaign(id))
    }
}

const campaignApi = new CampaignApi()
export default campaignApi


// WEBPACK FOOTER //
// ./src/component/app/campaign/CampaignApi.ts